import React from 'react'
import { Translate } from 'react-redux-i18n'

const Distribution = () => (
  <div>
    <h2>
      <Translate value="main.distribution_h" />
    </h2>
    <Translate value="main.distribution_html" dangerousHTML />
  </div>
)

export default Distribution



// WEBPACK FOOTER //
// ./src/containers/pages/distribution/distribution.js